// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/style/pivotviewer.css
// module id = 564
// module chunks = 3